import { IApiGetAppointments } from 'features/appointment/services/types/api';
import moment from 'moment';

export const renderTime = (dataAppointment: IApiGetAppointments | undefined) => {
    if (!dataAppointment) return;
    const isSameDate = moment(dataAppointment?.startTime).isSame(dataAppointment?.endTime);
    return isSameDate ? moment(dataAppointment?.startTime,'MM/DD/YYYY').format('MM/DD/YYYY') :
        `${moment(dataAppointment?.startTime,'MM/DD/YYYY').format('MM/DD/YYYY')} - ${moment(dataAppointment?.endTime, 'MM/DD/YYYY').format('MM/DD/YYYY')}`;
};